<template>
<div class="chapter">
<div class="inner_page">
<p class="front"><a id="page_ii"></a>STUDIES IN EARLY AMERICAN ECONOMY AND SOCIETY FROM THE LIBRARY COMPANY OF PHILADELPHIA</p>
<p class="front">Cathy Matson, <em>Series Editor</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Front.vue?2f97be8c